function trimContent(content, length) {
  const truncated = content.substr(0, length);
  if (truncated.length >= length) return `${truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf(' ')))} ...`;
  return truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf('')));
}

export default trimContent;
